import {LatLngTuple} from "leaflet";

export interface VoivObjects {
  title: string;
  value: string;
  key: number;
  coordinates: LatLngTuple,
  zoom: number

}

export const voivodeships: Array<VoivObjects> = [
  {
    title: "Wszystkie",
    value: "All",
    key: 0,
    coordinates: [52.36322, 19.13884],
    zoom: 6
  },
  {
    title: "Dolnośląskie",
    value: "Dsl",
    key: 1,
    coordinates: [50.958, 16.306],
    zoom: 8
  },
  {
    title: "Kujawsko-Pomorskie",
    value: "K-P",
    key: 2,
    coordinates: [53.059, 18.506],
    zoom: 8
  },
  {
    title: "Lubelskie",
    value: "Lbl",
    key: 3,
    coordinates: [51.284, 22.879],
    zoom: 8
  },
  {
    title: "Lubuskie",
    value: "Lbu",
    key: 4,
    coordinates: [52.252, 15.475],
    zoom: 8
  },
  {
    title: "Łódzkie",
    value: "Ldz",
    key: 5,
    coordinates: [51.627, 19.369],
    zoom: 8
  },
  {
    title: "Mazowieckie",
    value: "Maz",
    key: 6,
    coordinates: [52.265, 21.193],
    zoom: 7
  },
  {
    title: "Małopolskie",
    value: "Mal",
    key: 7,
    coordinates: [49.854, 20.252],
    zoom: 8
  },
  {
    title: "Opolskie",
    value: "Opo",
    key: 8,
    coordinates: [50.587, 17.801],
    zoom: 9
  },
  {
    title: "Podlaskie",
    value: "Pdl",
    key: 9,
    coordinates: [53.358, 22.770],
    zoom: 8
  },
  {
    title: "Podkarpackie",
    value: "Pkr",
    key: 10,
    coordinates: [49.920, 22.344],
    zoom: 8
  },
  {
    title: "Pomorskie",
    value: "Pom",
    key: 11,
    coordinates: [54.169, 18.174],
    zoom: 8
  },
  {
    title: "Śląskie",
    value: "Sl",
    key: 12,
    coordinates: [50.254, 19.005],
    zoom: 8
  },
  {
    title: "Świętokrzyskie",
    value: "Sw",
    key: 13,
    coordinates: [50.7675, 20.7868],
    zoom: 9
  },
  {
    title: "Wielkopolskie",
    value: "Wlkp",
    key: 14,
    coordinates: [52.398, 17.441],
    zoom: 7
  },
  {
    title: "Warmińsko-Mazurskie",
    value: "W-M",
    key: 15,
    coordinates: [53.802, 20.967],
    zoom: 8
  },
  {
    title: "Zachodniopomorskie",
    value: "Zpm",
    key: 16,
    coordinates: [53.610, 15.551],
    zoom: 8
  }
];
